import { render, staticRenderFns } from "./TabServicosTerceiros.vue?vue&type=template&id=13e7d3f8&scoped=true&"
import script from "./TabServicosTerceiros.vue?vue&type=script&lang=js&"
export * from "./TabServicosTerceiros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e7d3f8",
  null
  
)

export default component.exports